var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modalService"},[_c('transition',{attrs:{"name":"fade","mode":"in-out"}},[(_vm.modal)?_c(_vm.modal,{tag:"component"}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }